import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import { getDateString } from "./functions";

class OpisWyjazduData extends PureComponent<any> {
  static contextType = AppContext;

  render() {
    const { date } = this.props;
    const dateString = getDateString(date);
    return <section className="OpisWyjazduData">Data: {dateString}</section>;
  }
}

export default OpisWyjazduData;
